import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const directoriesQueryAtom = createQueryAtomFactory(
  'files.directories',
  (_params) => ({
    directories: {
      __args: {},
      id: true,
      fileName: true,
      fileType: true,
      parentId: true,
      public: true,
      template: true,
      path: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
      creator: {
        id: true,
        firstName: true,
        lastName: true,
      },
    },
  }),
  {
    select: ({ directories }) => directories,
  },
);
